<template>
  <el-form v-loading="boxFixedLoading"
           :model="userForm"
           :rules="rules"
           size="mini"
           ref="userFormSystem"
           label-width="120px"
           class="userForm"
  >
    <el-form-item label="用户名" prop="username">
      <el-input v-model.trim="userForm.username"></el-input>
    </el-form-item>
    <el-form-item label="账户密码" prop="password">
      <el-input v-model.trim="userForm.password" auto-complete="off"></el-input>
    </el-form-item>
    <el-form-item label="角色" prop="roles">
      <role-selcet type="multiple" v-model="userForm.roleIds"/>
    </el-form-item>
    <el-form-item label="部门">
      <el-cascader
        class="dept-select"
        :options="depts"
        :props="cascderProps"
        @change="departChange"
        v-model="deptList"
      >
        <template #default="{ node, data }">
          <div class="cascader-item">
            <span>{{ node.label }}</span>
            <el-switch
              v-model="data.leader"
              active-text="领导"
              class="is-leader-switch"
              @change="onleaderChange(data)"
            ></el-switch>
          </div>
        </template>
      </el-cascader>
    </el-form-item>
    <el-form-item label="常驻站点" prop="site">
      <el-select v-model="userForm.site" placeholder="请选择常驻站点（默认上海）" clearable>
        <el-option label="上海" :value="1"></el-option>
        <el-option label="苏州" :value="2"></el-option>
        <el-option label="合肥" :value="3"></el-option>
      </el-select>
    </el-form-item>
    <!--分为无激活权限、限时激活码、永久激活码-->
    <el-form-item label="类型" prop="level" v-if="actions.includes('永久激活码') ||actions.includes('限时激活码')">
      <el-radio v-if="actions.includes('永久激活码')" v-model="userForm.level" label="1" @change="changeLevel">
        永久激活码
      </el-radio>
      <el-radio v-if="actions.includes('限时激活码')" v-model="userForm.level" label="2" @change="changeLevel">
        限时激活码
      </el-radio>
    </el-form-item>
    <el-form-item label="可生成最大天数" prop="maxActivateDays" v-if="userForm.level==2">
      <el-input-number style="width: 100%" :min="1" :max="userForm.level===1?9999:360" :precision="0" :controls="false"
                       placeholder="N/A" v-model.trim="userForm.maxActivateDays"></el-input-number>
    </el-form-item>
    <el-form-item label="可生成次数" prop="remainingActivateTimes"
                  v-if="userForm.level==1 || userForm.level==2">
      <el-input-number style="width: 100%" :min="1" :precision="0"
                       :controls="false" placeholder="N/A"
                       v-model.trim="userForm.remainingActivateTimes"></el-input-number>
    </el-form-item>
    <el-form-item prop="email" label="邮箱">
      <el-input v-model="userForm.email">
        <template #suffix>
          <el-select v-model="userForm.domain">
            <el-option label="@techik.cn" value="@techik.cn"></el-option>
            <el-option label="@techik.net" value="@techik.net"></el-option>
            <el-option label="@techiksafety.cn" value="@techiksafety.cn"></el-option>
            <el-option label="@rayman-tech.com" value="@rayman-tech.com"></el-option>
          </el-select>
        </template>
      </el-input>
    </el-form-item>
    <el-form-item label="备注" prop="description">
      <el-input v-model.trim="userForm.description"></el-input>
    </el-form-item>
    <el-form-item>
        <span class="btns">
          <el-button type="primary" @click="ajaxPost('add')" v-if="isAdd">确 定</el-button>
          <el-button type="primary" @click="ajaxPost('edit')" v-else>确 定</el-button>
          <el-button type="info" @click="cancel()">取 消</el-button>
          <el-button type="warning" @click="pastePermission()">粘贴权限</el-button>
        </span>
    </el-form-item>
  </el-form>
</template>

<script>
import {basementAjax} from "@/common/ajax.js";
import RoleSelcet from "../../../components/RoleSelcet.vue";
import {basementAjaxGet} from "../../../common/ajax";
import PermissionButton from "../../../components/PermissionButton.vue";
import store from "../../../store";
import {isNull} from "xe-utils";

export default {
  name: "add",
  components: {PermissionButton, RoleSelcet},
  data() {
    return {
      boxFixedLoading: false,
      userForm: {
        username: "",
        password: "",
        level: "",
        maxActivateDays: 0,
        remainingActivateTimes: 0,
        email: null,
        domain: "@techik.cn",
        description: "",
        permission: "tradeSale",
        roleIds: [],
        departmentDtos: [],
        site: null,
      },
      rules: {
        username: [{required: true, message: "请输入用户名", trigger: "blur"}],
        password: [{required: true, message: "请设置密码", trigger: "blur"}],
        // level: [{required: true, message: "请选择用激活码类型", trigger: "blur"}],
        // maxActivateDays: [
        //   {required: true, message: "请输入天数", trigger: "blur"},
        //   {pattern: /^[1-9]+[0-9]*$/, message: "请输入正整数", trigger: "blur"},
        // ],
        // remainingActivateTimes: [
        //   {required: true, message: "请输入次数", trigger: "blur"},
        //   {pattern: /^[1-9]+[0-9]*$/, message: "请输入正整数", trigger: "blur"},
        // ],
        email: [
          {
            required: false, trigger: "blur", validator: (r, v, c) => {
              if (null == v || '' == v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.userForm.email + this.userForm.domain)) {
                c()
              } else c(new Error("请输入正确的邮箱地址!"))
            }
          }
        ],
      },
      cascderProps: {multiple: true, children: 'childrenDeptList', label: 'name', value: 'id'},
      depts: [],
      deptList: [],
      actions: []
    };
  },
  props: ["isAdd", "isEdit", "edit_id"],
  mounted() {
    if (this.isAdd) {
      this.resetForm();
    } else if (this.isEdit) {
      this.getInfo(this.edit_id);
    }

    this.getDepartList(); // 先获取部门列表
    this.getActionPoints()
  },
  watch: {
    isAdd(curVal) {
      if (curVal) {
        this.resetForm();
      }
      this.initDeptList();
    },
    edit_id(curVal) {
      if (curVal) {
        this.getInfo(this.edit_id);
      }
    },
  },
  methods: {
    pasteRole(row) {
      console.log(row)
      this.userForm.roleIds = [...row.roleIds];
      this.userForm.departmentDtos = [...row.departmentDtos];
      this.initDeptList();
    },
    getInfo(idx) {
      this.boxFixedLoading = true;
      basementAjax(
        this,
        "/techik/user/getUserDetailedInfo",
        {userId: idx},
        (res) => {
          this.userForm = res.data.data;
          this.$set(this.userForm, 'domain', "@techik.cn")

          if (this.userForm.email) {
            const arr = this.userForm.email.split("@")
            if (arr.length === 2) {
              this.userForm.email = arr[0]
              this.userForm.domain = "@" + arr[1]
            }
          }
          this.userForm.totalActivateTimes = res.data.data.totalActivateTimes;
          this.userForm.level = String(res.data.data.level);
          this.initDeptList();
          this.boxFixedLoading = false;
        },
        (res) => {
          this.$message.error(res.data.message);
          this.boxFixedLoading = false;
        }
      );
    },
    initDeptList() {
      this.clearAllLeaders(this.depts);
      const arr = this.userForm.departmentDtos;
      this.deptList = arr.map(item => this.getParentsById(this.depts, item['deptId'], item['leader']));
    },
    clearAllLeaders(list) {
      list.forEach(item => {
        item.leader = false;
        if (item.childrenDeptList) {
          this.clearAllLeaders(item.childrenDeptList);
        }
      });
    },
    getParentsById(list, id, leader = false) {
      for (let i in list) {
        if (list[i].id === id) {
          if (!list[i].leader) list[i].leader = leader;
          return [list[i].id];
        }
        if (list[i].childrenDeptList) {
          let node = this.getParentsById(list[i].childrenDeptList, id, leader);
          if (node !== undefined) {
            node.unshift(list[i].id);
            return node;
          }
        }
      }
    },
    getDepartList() {
      basementAjaxGet(
        this,
        '/techik/dept/tree',
        res => {
          this.depts = res.data.data;
          this.recursiveDeletionOfEmptySubentries();
          this.initDeptList(); // 在获取部门数据后再初始化部门列表
        },
        error => {
          this.$message.error('获取部门数据失败');
        }
      );
    },
    departChange(value) {
      const arr = value.flat(); // 获取已选择的部门ID

      // 获取所有选中的部门
      this.userForm.departmentDtos = arr.map(deptId => {
        return {deptId, leader: false};
      });

      // 遍历所有部门，检查并删除没有子级被选中的父级部门
      this.userForm.departmentDtos = this.userForm.departmentDtos.filter(dept => {
        const hasChildren = this.hasChildDept(this.depts, dept.deptId);
        if (!hasChildren) return true; // 如果没有子级，则保留该部门

        // 如果有子级，检查这些子级是否在已选中部门中
        const childrenSelected = this.depts.some(item => {
          return item.id === dept.deptId && item.childrenDeptList && item.childrenDeptList.some(child =>
            arr.includes(child.id)
          );
        });

        return childrenSelected; // 只有在有子级被选中的情况下保留该部门
      });
    },

    hasChildDept(departments, deptId) {
      for (let department of departments) {
        if (department.id === deptId) {
          return department.childrenDeptList && department.childrenDeptList.length > 0;
        }
        if (department.childrenDeptList) {
          const hasChildren = this.hasChildDept(department.childrenDeptList, deptId);
          if (hasChildren) return true;
        }
      }
      return false;
    },
    onleaderChange(data) {
      const department = this.userForm.departmentDtos.find(dept => dept.deptId === data.id);
      if (department) {
        department.leader = data.leader;
        this.updateChildLeaders(data, data.leader);
        this.updateParentLeaders(data);
      }
    },
    updateChildLeaders(node, isLeader) {
      if (node.childrenDeptList) {
        node.childrenDeptList.forEach(child => {
          child.leader = isLeader;
          this.updateChildLeaders(child, isLeader);
        });
      }
    },
    updateParentLeaders(node) {
      const parent = this.findParent(this.depts, node);
      if (parent) {
        const allSiblingsAreLeaders = parent.childrenDeptList.every(child => child.leader);
        parent.leader = allSiblingsAreLeaders;
        this.updateParentLeaders(parent);
      }
    },
    findParent(list, child) {
      for (let node of list) {
        if (node.childrenDeptList && node.childrenDeptList.some(c => c.id === child.id)) {
          return node;
        }
        if (node.childrenDeptList) {
          const parent = this.findParent(node.childrenDeptList, child);
          if (parent) return parent;
        }
      }
      return null;
    },
    recursiveDeletionOfEmptySubentries(arr) {
      if (!arr) {
        arr = this.depts;
      }
      arr.forEach(item => {
        if (!item.childrenDeptList || item.childrenDeptList.length === 0) {
          delete item.childrenDeptList;
        } else {
          this.recursiveDeletionOfEmptySubentries(item.childrenDeptList);
        }
      });
    },
    ajaxPost(type) {
      let that = this;
      let obj = that.userForm;
      let prams = {
        username: obj.username,
        password: obj.password,
        status: true,
        level: obj.level,
        email: obj.email + obj.domain,
        maxActivateDays: obj.maxActivateDays,
        remainingActivateTimes: obj.remainingActivateTimes,
        description: obj.description,
        permission: obj.permission,
        roleIds: obj.roleIds,
        departmentDtos: obj.departmentDtos,
        site: obj.site,
      };
      let url = type === "edit" ? "/techik/user/update" : "/techik/user/addUser";
      if (type === "edit") {
        prams["userId"] = this.edit_id;
        prams['totalActivateTimes'] = obj.totalActivateTimes;
      }
      that.$refs["userFormSystem"].validate(valid => {
        if (valid) {
          that.boxFixedLoading = true;
          basementAjax(
            that,
            url,
            prams,
            res => {
              that.$message.success("成功");
              that.boxFixedLoading = false;
              that.resetForm();
              that.$emit("closeDialog");
              that.$emit("getData");
            },
            res => {
              that.$message.error(res.data.message);
              that.boxFixedLoading = false;
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changeLevel(e) {
      if (e == 1) {
        this.userForm.maxActivateDays = 9999;
      } else {
        this.userForm.maxActivateDays = 0;
      }
      this.userForm.remainingActivateTimes = 0;
    },
    resetForm() {
      this.$refs["userFormSystem"].resetFields();
      this.userForm = {
        username: "",
        password: "",
        level: "",
        maxActivateDays: 0,
        remainingActivateTimes: 0,
        email: null,
        domain: "@techik.cn",
        description: "",
        permission: "tradeSale",
        roleIds: [],
        departmentDtos: [],
        site: null,
      };
    },
    cancel() {
      this.$emit("closeDialog");
      this.resetForm();
    },
    getActionPoints() {
      const allActions = store.getters['permission/getCurrentMenu']['actionPoints'];
      this.actions = allActions.map(item => item.name);
      console.log(this.actions)
    },
    pastePermission() {
      const that = this;
      if (!navigator.clipboard) {
        // 回退方案：创建隐藏输入框模拟粘贴
        const textarea = document.createElement('textarea');
        document.body.appendChild(textarea);
        textarea.focus();
        if (document.execCommand('paste')) {
          try {
            const text = textarea.value;
            that.parseClipboardText(text);
          } catch (e) {
            that.$message.error('解析失败');
          }
        } else {
          that.$message.error('浏览器不支持剪贴板访问');
        }
        document.body.removeChild(textarea);
        return;
      }

      // 正常调用 Clipboard API
      navigator.clipboard.readText().then(text => {
        that.parseClipboardText(text);
      }).catch(err => {
        console.error('剪贴板读取失败:', err);
        that.$message.error('请检查浏览器权限或使用 HTTPS');
      });
    },
    parseClipboardText(text) {
      try {
        const obj = JSON.parse(text);
        if (!obj.copyMarking) throw new Error('无效数据');
        this.userForm.departmentDtos = obj.departmentDtos;
        this.userForm.roleIds = obj.roleIds;
        this.initDeptList();
      } catch (e) {
        this.$message.error('数据格式错误');
      }
    }
  },
};
</script>


<style scoped>
.el-select {
  width: 100%;
}

.btns {
  text-align: center;
}

.dept-select {
  width: 100%;
}

.cascader-item {
  width: 250px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.is-leader-switch {
  margin-left: auto;
}

</style>



// WEBPACK FOOTER //
// src/views/system/user/add.vue